import * as Yup from "yup";

const registerValidationSellerPF = Yup.object().shape({
  email: Yup.string()
    .email("Digite um e-mail válido")
    .required("Campo obrigatório"),
  password: Yup.string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("Campo obrigatório"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password")], "As senhas devem coincidir")
    .required("Campo obrigatório"),
  business_name: Yup.string().required("Campo obrigatório"),
  document: Yup.string()
    .min(11, "O CPF deve ter pelo menos 6 caracteres")
    .required("Campo obrigatório"),
  phone: Yup.string().required("Campo obrigatório"),
});

export default registerValidationSellerPF;
